<template>
  <v-dialog v-model="dialog" @click:outside="cancel" no-click-animation :width="st <= 1 ? 800 : 1000">
    <v-stepper v-if="dialog" v-model="st">
      <v-stepper-header>
        <template v-for="(item, idx) in steps">
          <v-stepper-step :step="idx+1" :complete="st > idx + 1">{{ $t(item.text) }}</v-stepper-step>
          <v-divider v-if="idx < steps.length" />
        </template>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content :step="1">
          <app-deploy-welcome @next="nexts['welcome']" @cancel="cancel" />
        </v-stepper-content>
        <v-stepper-content :step="2">
          <app-deploy-pick v-if="st >= 2" @next="nexts['pick']" @prev="st--" @cancel="cancel" />
        </v-stepper-content>
        <v-stepper-content :step="3">
          <app-deploy-location v-if="st >= 3" :device="params.deploymentMethod" @next="nexts['location']" @prev="st--" @cancel="cancel" />
        </v-stepper-content>
        <v-stepper-content :step="4">
          <app-deploy-install v-if="st >= 4" :params="params" @next="cancel" @prev="st--" @cancel="cancel" />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import DeployWelcomeComponent from '@/components/DeployWelcome.vue'
import DeployPickComponent from '@/components/DeployPick.vue'
import DeployLocationComponent from '@/components/DeployLocation.vue'
import DeployInstallComponent from '@/components/DeployInstall.vue'
import { alphanumeric } from '@/services/compose'
import { v4 as uuidv4 } from 'uuid'

export default {
  data () {
    return {
      dialog: false,
      nexts: {
        'welcome': () => this.st++,
        'pick': (method) => {
          this.params.deploymentMethod = method
          this.st++
        },
        'location': (location) => {
          this.params.location = location
          this.st++
        }
      },
      params: {
        adminPassword: alphanumeric(10),
        deploymentMethod: undefined,
        deployment: undefined,
        location: undefined,
        uuid: uuidv4().substring(0, 8)
      },
      st: 1,
      steps: [
        { text: 'welcome'},
        { text: 'pick'},
        { text: 'location'},
        { text: 'deploy'}
      ]
    }
  },
  props: {
    deployment: String,
    open: Boolean
  },
  watch: {
    open (newVal) {
      if (newVal) {
        this.st = 1
      }
      this.dialog = newVal
    }
  },
  created () {
    this.params.deployment = this.deployment
  },
  methods: {
    cancel () {
      this.st = 1
      this.init()
      this.dialog = false
      this.$emit('close')
    },
    init () {
      this.params.adminPassword = alphanumeric(10)
      this.params.uuid = uuidv4().substring(0, 8)
    }
  },
  components: {
    'app-deploy-welcome': DeployWelcomeComponent,
    'app-deploy-pick': DeployPickComponent,
    'app-deploy-location': DeployLocationComponent,
    'app-deploy-install': DeployInstallComponent
  }
}
</script>

<i18n>
{
  "en": {
    "welcome": "Goal",
    "pick": "Pick Deployment",
    "location": "Select Location",
    "deploy": "Deploy"
  }
}
</i18n>

<style lang="scss">
.v-stepper {
  border-radius: 0;
}

.v-stepper__header {
  margin-bottom: 5px;
}

.v-stepper__items {
  &, .v-stepper__wrapper {
    overflow: visible;
  }
}

.v-stepper__content {
  padding: 0;
}

@media (max-height: 730px) {
  .v-stepper__header {
    display: none;
  }
}
</style>
